var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"site-masthead container header-white"},[_vm._m(0),_c('h4',[_vm._v(_vm._s(_vm.headerTitle))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"site-logo"},[_c('img',{attrs:{"src":require("@/assets/images/logos/cl-mark.svg"),"alt":"Crucial Learning Logo"}})])
}]

export { render, staticRenderFns }